import type { PlayerIndex } from '@tpubg/shared';

export type CpuLevel = 'easy' | 'normal' | 'hard';
export const CPU_LEVELS: readonly CpuLevel[] = ['easy', 'normal', 'hard'];
export const CPU_LEVEL_LABEL: Record<CpuLevel, string> = { easy: 'Easy', normal: 'Normal', hard: 'Hard' };

/** In vs-computer games the human is always Player 1 and the computer is Player 2. */
export const CPU_PLAYER: PlayerIndex = 1;

export interface CpuSetting {
  player: PlayerIndex;
  level: CpuLevel;
}

export function parseLevel(v: string | null): CpuLevel {
  return v === 'easy' || v === 'hard' ? v : 'normal';
}
